import { useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
var EMPTY_VALUES = {
    name: "",
    value: "",
};
export var useRecordPropertiesPanel = function (props) {
    var _a = useForm({
        mode: "onTouched",
        defaultValues: EMPTY_VALUES,
    }), control = _a.control, handleSubmit = _a.handleSubmit, reset = _a.reset;
    useEffect(function () {
        if (props.editingRow) {
            reset({
                name: props.editingRow.name,
                value: props.editingRow.value,
            });
        }
        else {
            reset(EMPTY_VALUES);
        }
    }, [props.editingRow, reset]);
    var watchedName = useWatch({ control: control, name: "name" });
    var watchedValue = useWatch({ control: control, name: "value" });
    var canSubmit = Boolean((watchedName === null || watchedName === void 0 ? void 0 : watchedName.trim()) && (watchedValue === null || watchedValue === void 0 ? void 0 : watchedValue.trim()));
    var onSubmit = handleSubmit(function (values) {
        props.onSubmit(values.name, values.value);
        reset(EMPTY_VALUES);
    });
    var onCancel = function () {
        reset(EMPTY_VALUES);
        props.onCancelEdit();
    };
    return {
        control: control,
        isEditing: Boolean(props.editingRow),
        canSubmit: canSubmit,
        onSubmit: onSubmit,
        onCancel: onCancel,
    };
};
